import classes from "./FormEducation.module.css";
import { useCurrentDataContext } from "../../../contexts/CurrentDataContext";
import { useTranslation } from "react-i18next";
import { EducationLevel } from "../../../contexts/interfaces";

interface Props {
  options: EducationLevel[];
}

const FormEducationSelect = ({ options }: Props) => {
  const { currentData, setCurrentData } = useCurrentDataContext();

  // Set translation
  const { t } = useTranslation();

  const checkEducationLevel = (value: string) => {
    // Find correct option with select value (id)
    let option = options.find((option) => option.id === Number(value));

    // Return title
    return option?.title || "";
  };

  return (
    <>
      <div>{t("formEducation.applicantEducation")}</div>
      <select
        className={classes.formEducationSelect}
        defaultValue={currentData?.educationId}
        onChange={(e) =>
          currentData &&
          setCurrentData({
            ...currentData,
            educationId: Number(e.target.value),
            educationLevel: checkEducationLevel(e.target.value),
            ...(Number(e.target.value) === 7
              ? { isRegistered: false, registerNumber: null }
              : {}),
          })
        }
      >
        {!currentData?.educationLevel && (
          <option hidden value="">
            {`--- ${t("formEducation.chooseApplicantEducation")} ---`}
          </option>
        )}

        {options.map((option) => {
          return (
            <option key={option.id} value={option.id}>
              {option.title}
            </option>
          );
        })}
      </select>
    </>
  );
};

export default FormEducationSelect;
/* 
import classes from './FormEducation.module.css';
import { useCurrentDataContext } from '../../../contexts/CurrentDataContext';
import { useTranslation } from 'react-i18next';
import { EducationLevel } from '../../../contexts/interfaces';
import Select from 'react-select';
import { useEffect, useState } from 'react';

interface Props {
    options: EducationLevel[],
};

interface SearchLabel {
    value: string,
    label: string
};

const FormEducationSelect = ({ options }: Props) => {
    const { currentData, setCurrentData } = useCurrentDataContext();

    const [searchOptions, setSearchOptions] = useState<SearchLabel[]>([]);

    const [selectedEducationLevel, setSelectedEducationLevel] = useState<SearchLabel>({ label: "", value: "" });

    // Set translation
    const { t } = useTranslation();

    useEffect(() => {
        setSelectedEducationLevel({ label: currentData?.educationLevel || options[0].title, value: String(currentData?.educationId || options[0].id) })
    }, [currentData?.educationId, options])

    useEffect(() => {
        setSearchOptions(options.map(option => {
            return {
                label: `${option.title}`, value: String(option.id)
            }
        }))
    }, [options]);

    const checkEducationLevel = (value: string) => {
        // Find correct option with select value (id)
        let option = options.find(option => option.id === Number(value));

        // Return title
        return option?.title || ""
    };

    return (
        <>
            <div>{t('formEducation.applicantEducation')}</div>
            {selectedEducationLevel.value !== "" &&
                <Select
                    defaultValue={selectedEducationLevel}//{{ label: checkEducationLevel(String(currentData?.educationId)), value: String(options.find(option => option.id === currentData?.educationId)?.id) || "" }}
                    isSearchable={false}
                    className={classes.formEducationSelect}
                    options={searchOptions}
                    placeholder={t('formEducation.chooseApplicantEducation')}
                    onChange={(e) => e && currentData && setCurrentData(
                        {
                            ...currentData,
                            educationId: Number(e.value),
                            educationLevel: checkEducationLevel(e.value)
                        }
                    )}
                    noOptionsMessage={({ inputValue }) => inputValue ? t("formEducation.chooseApplicantEducation") : null}
                    isClearable={false}
                // components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                />
            }
        </>
    )
};

export default FormEducationSelect;
 
*/
